module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/narrow-col-action-offer/narrow-col-action-offer.component.scss
// module id = ./src/app/modules/common-module/components/narrow-col-action-offer/narrow-col-action-offer.component.scss
// module chunks = 9